<template>
  <dl
    ref="target"
    class="select-box"
  >
    <dt @click="onClick">
      <span>{{ list[curIndex] ? list[curIndex].label : '' }}</span>
      <div class="icon-wrap">
        <svg-icon
          :class="{ down: visible }"
          icon-class="icon-arrowleft"
        />
      </div>
    </dt>
    <dl v-show="visible">
      <template v-for="(item, i) in list">
        <span
          v-if="item && item.active"
          :key="i"
          :class="{ active: curIndex === i }"
          @click="change(i)"
        >
          {{ item.label }}
        </span>
      </template>
    </dl>
  </dl>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { onClickOutside } from '@vueuse/core'

export default {
  name: 'ComboMarketSelect',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const target = ref(null)
    const curIndex = ref(0)
    const visible = ref(false)

    watch(
      () => props.index,
      (val) => {
        curIndex.value = val
      }
    )

    const change = (index) => {
      curIndex.value = index
      visible.value = !visible.value
      emit('change', index)
    }

    const onClick = () => {
      visible.value = !visible.value
    }

    onClickOutside(target, () => {
      visible.value = false
    })

    return {
      target,
      curIndex,
      visible,
      change,
      onClick
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~wap/common/style/_mixin" as mixin;

.select-box {
  position: relative;
  width: 108px;
  margin: 0 6px 12px 0;

  dt {
    display: flex;
    width: 108px;
    height: 28px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    padding: 0 4px 0 10px;
    border: 1px solid #2c2c2c;
    border-radius: 8px;
    background: #1e1e1e;
    line-height: 28px;

    span {
      flex: 1;
      color: #fff;

      @include mixin.ellipsis();
    }

    .icon-wrap {
      display: flex;
      width: 20px;
      height: 20px;
      align-items: center;
      justify-content: center;
      margin-left: 4px;

      svg {
        width: 16px;
        height: 16px;
        fill: #fff;
        transform: rotate(-90deg);
        transition: all 300ms;
        vertical-align: unset;
      }

      .down {
        transform: rotate(90deg);
      }
    }
  }

  dl {
    position: absolute;
    z-index: 15;
    top: 42px;
    left: 0;
    min-width: 108px;
    box-sizing: border-box;
    padding: 0 12px;
    border-radius: 8px;
    background: #222;
    filter: drop-shadow(0 0 10px #000);

    &::before {
      position: absolute;
      top: -6px;
      right: 10px;
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      border-bottom: none;
      border-left: none;
      background: #222;
      content: "";
      transform: rotate(-45deg);
    }

    span {
      display: block;
      height: 44px;
      box-sizing: border-box;
      border-bottom: 1px solid #333;
      color: #fff;
      font-size: 14px;
      line-height: 44px;

      @include mixin.ellipsis();

      &.active {
        color: #ffd75b;
      }

      &:last-child {
        border: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .select-box {
  dt {
    border-color: #ececec;
    background: #fff;

    span {
      color: #333;
    }

    .icon-wrap svg {
      fill: #333;
    }
  }
}
</style>
